export const E_APPLICATION_SETTINGS_RESET_STATE = 'E_APPLICATION_SETTINGS_RESET_STATE';
export const E_APPLICATION_SETTINGS_CURRENT_ITEM = 'E_APPLICATION_SETTINGS_CURRENT_ITEM';

export const E_APPLICATION_SETTINGS_REQUEST_LOADING = 'E_APPLICATION_SETTINGS_REQUEST_LOADING';
export const E_APPLICATION_SETTINGS_REQUEST_SUCCESS = 'E_APPLICATION_SETTINGS_REQUEST_SUCCESS';
export const E_APPLICATION_SETTINGS_REQUEST_FAILED = 'E_APPLICATION_SETTINGS_REQUEST_FAILED';

export const E_APPLICATION_SETTINGS_CURRENT_ACTION = 'E_APPLICATION_SETTINGS_CURRENT_ACTION';
export const E_APPLICATION_SETTINGS_RESET_ACTION = 'E_APPLICATION_SETTINGS_RESET_ACTION';